import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { TestQueryService } from '../../test-query.service';

@Injectable({
  providedIn: 'root'
})
export class TypeService {

  saveFlag:any = false;
  number1:any = [];
  changRefresh:any = -1;

  // 单个图形的配置
  public editList = [
    {name:"图形宽度",spans:""},
    {name:"图形宽度",spans:""},
    {name:"图形宽度",spans:""},
    {name:"图形宽度",spans:""},
  ]
  private subject = new Subject<any>();
  private subject1 = new Subject<any>();
  private subject2 = new Subject<any>();
  private subject3 = new Subject<any>();
  private subject4 = new Subject<any>();
  private subject5 = new Subject<any>();
  private subject6 = new Subject<any>();
  private subject7 = new Subject<any>();
  private subject8 = new Subject<any>();
  private subject9 = new Subject<any>();
  private subject10 = new Subject<any>();

  constructor(private ml:TestQueryService) { }
  // 发送几行几列
  sendline(line) {
    this.subject.next(line);
  }

  getline(): Observable<any> {
      return this.subject.asObservable();
  }

  // 点击图形添加数据
  sendrun(data:any){
    let dataS = "total-data";
    if (data.type == 'timeseries') {
      dataS = "passdata";

      // 新增
      console.log(data.type);
    }else if(data.type == 'bilibala-echarts-panel'){
      dataS = "teamdata";

      // 新增
      console.log(data.type);
    }
      this.subject1.next(
        {oneType:data.type,name:"新建图形",state:"1",datasource:dataS,spans:4,oneHeight:"250px",orientation: data.orientation?data.orientation:"",stacking:data.stacking?data.stacking:"",typeName:data.typeName?data.typeName:""},
      )
  }
  getrun(): Observable<any>{
    return this.subject1.asObservable();
  }
  // 获取修改属性
  sendattribute(res:any,index:any){
    this.subject3.next({datas:res,current:index});
  }
  getattribute(): Observable<any> {
    return this.subject3.asObservable();
  }
  // 删除图形
  senddeletepic(index:any){
    this.subject7.next(index);
  }
  getdeletepic(): Observable<any> {
    return this.subject7.asObservable();
  }
  // 重置页面
  sendpage(picId){
    // 修改页面的id   ml.set(picId);
    this.ml.setId(picId);
    this.subject4.next();
  }
  getpage(): Observable<any> {
    return this.subject4.asObservable();
  }
  // 点击保存
  sendpre(preservation){
    this.saveFlag = preservation;
    this.subject2.next(this.saveFlag);
  }
  getpre(): Observable<any> {
    return this.subject2.asObservable();
  }
  // 打开存储的图表
  sendopen(res:any){
    this.subject5.next(res)
  }
  getopen(): Observable<any> {
    return this.subject5.asObservable();
  }
  // 发布
  sendrelease(){
    this.subject8.next();
  }
  getrelease(): Observable<any> {
    return this.subject8.asObservable();
  }
  // 修改刷新时间
  sendrefresh(res:any){
    this.subject8.next(res);
  }
  getrefresh(){
    return this.subject8.asObservable();
  }
  // 修改刷新时间
  sendBasic(){
    this.subject9.next();
  }
  getBasic(){
    return this.subject9.asObservable();
  }
  // 修改展示内容时间
  sendShowTime(res:any){
    this.subject10.next(res);
  }
  getShowTime(){
    return this.subject10.asObservable();
  }

}
